const baseRoutes = [
  {
    path: 'menu/arming',
    component: () => import("@/_routes/tabs/menu/arming/Root"),
  },
  {
    path: 'menu/arming/home',
    component: () => import("@/_routes/tabs/menu/arming/Home")
  },
  {
    path: 'menu/arming/away',
    component: () => import("@/_routes/tabs/menu/arming/Away")
  },
  {
    path: 'menu/arming/armed',
    component: () => import("@/_routes/tabs/menu/arming/Armed")
  },
  {
    path: 'menu/arming/entry',
    component: () => import("@/_routes/tabs/menu/arming/EntryDelay")
  },
  {
    path: 'menu/arming/exit',
    component: () => import("@/_routes/tabs/menu/arming/ExitDelay")
  },
  {
    path: 'menu/arming/bell',
    component: () => import("@/_routes/tabs/menu/arming/BellDuration")
  },
]

const routes = baseRoutes

export default routes
